import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get} from '../../request'
import './styles.scss';

function ImageUpload({ imageTitle, className, name, evidenceType, uploaded, deleted, imageSrc}) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [imageSrc1, setImageSrc] = useState(imageSrc||"");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const fileInputRef = useRef(null);
    useEffect(() => {
        setImageSrc(imageSrc);
    }, [imageSrc]);

    function compressImage(file, quality = 0.8) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    // ������Ҫ����canvas�ĳߴ�  
                    canvas.width = img.width; // ���߸�С�ĳߴ���ѹ��ͼƬ  
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    const compressedDataUrl = canvas.toDataURL('image/jpeg', quality);
                    resolve(compressedDataUrl);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        });
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            compressImage(file)
                .then((compressedDataUrl) => {
                    setImageSrc(compressedDataUrl);
                    setSelectedFile(file);
                    uploaded(name, compressedDataUrl, evidenceType);

                })
                .catch((error) => {
                    console.error('Error compressing image:', error);
                });


        }
    };
    
    const handleClick = () => {
        if (imageSrc1) {
            handleViewImage();
        }
        else {
            fileInputRef.current.click();
            return;
        }
    };
    const handleViewImage = () => {
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
    };
    const handleDeleteClick = () => {
        //setImageSrc("");
        setSelectedFile(null);
        fileInputRef.current.value = null;
        if (deleted) {
            deleted(name, evidenceType, imageSrc1);
        }
    }
    return (
        <div className={`imageUpload ${className}`} >
            {
                imageSrc1 && <div className="deleteIcon" onClick={handleDeleteClick}></div>
            }            
            {!imageSrc1 &&
                <div className="addImage" onClick={handleClick}></div>}
            {!imageSrc1 &&
            <div className="imageTitle" >{ imageTitle }</div>
            }
            <input hidden type="file" accept="image/*" ref={fileInputRef } onChange={handleFileChange}  />
            {(imageSrc1) &&
                <img className="uploadImage" src={imageSrc1} alt="Uploaded Image" onClick={handleClick} />}

            {isModalVisible && (
                <div className="modal" onClick={handleCloseModal}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className="modal-close" onClick={handleCloseModal}></div>
                        <img src={imageSrc1} alt="Uploaded Image" style={{ maxWidth: '100%', maxHeight: '80vh' }}  />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ImageUpload;